// FILE: src/hooks/usePermissions.js
// const { can, staffRole } = usePermissions(); can("students.lock") → boolean.
// See src/auth/permissions.js for what a need can be.
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { canDo, permissionsOf } from "../auth/permissions";

export default function usePermissions() {
  const user = useSelector((s) => s.auth.user);
  const role = useSelector((s) => s.auth.role);
  return useMemo(() => {
    const auth = { user, role };
    return {
      can: (need) => canDo(auth, need),
      permissions: permissionsOf(auth),
      staffRole: user?.staffRole || null
    };
  }, [user, role]);
}

/** Shorthand: useCan("audit.view"). */
export function useCan(need) {
  return usePermissions().can(need);
}
